import AllhomesBreadcrumbs from './allhomes-breadcrumbs';
export default AllhomesBreadcrumbs;